import React from 'react';
import Question from './question';
const Questions = ({
  questionIds
}: {
  questionIds: string[];
}): React.ReactElement => {
  return <div>
      {questionIds.map(questionId => {
      return <Question key={questionId} questionId={questionId} />;
    })}
    </div>;
};
export default Questions;